import {Injectable} from '@angular/core';
import {AuthService} from '../security/auth.service';
import {GenericService} from '../commons/generic.service';
import {User} from '../domain/user';
import {QueryOptions} from '../commons/query.options';
import {Observable} from 'rxjs/Observable';
import {RequestMethod, RequestOptionsArgs, URLSearchParams} from '@angular/http';
import {Role} from '../domain/role';
import {PaginationPage} from '../commons/pagination-page';

@Injectable()
export class UserService extends GenericService<User> {

    private userUrl = '/users';

    constructor(authService: AuthService) {
        super(authService)
    }

    public resetPass(user: User): Observable<User> {
        const req = this.buildRequest(RequestMethod.Post);
        return this.authService.authRequest(this.baseUrl + this.userUrl + '/' + user.id + '/reset_password', req)
            .map(res => this.valueToEntity(res.json()));
    }

    public changePass(oldPass: string, newPass: string): Observable<User> {
        const req = this.buildRequest(RequestMethod.Post, JSON.stringify({oldPassword: oldPass, newPassword: newPass}));
        return this.authService.authRequest(this.baseUrl + this.userUrl + '/change_password', req)
            .map(res => this.valueToEntity(res.json()));
    }

    public findByValue(value: string): Observable<User[]> {
        const req = this.buildRequest(RequestMethod.Get);
        req.params = new URLSearchParams();
        req.params.set('value', value);
        return this.authService.authRequest(this.baseUrl + this.userUrl + '/find', req)
            .map(res => res.json().map( t => this.valueToEntity(t) ) );
    }

    public pagedSearch(terms: string, enabled: string,
                       queryOptions: QueryOptions = this.getDefaultQueryOptions()): Observable<PaginationPage<User>> {
        const ro = queryOptions.getQueryRequestOptions().merge({
            url: this.baseUrl + this.getResourcePath() + '/search'});
        if (terms) {
            ro.params.append('terms', terms)
        }

        ro.params.append('enabled', enabled);
        return this.doRequest(ro)
            .map(res => res.json())
            .concatMap(json => Observable.from(json.content)
                .concatMap(value => this.mapValueToEntityQuery(value))
                .toArray()
                .map(content => new PaginationPage({...json, content: content}))
            );
    }

    public findByRole(role: Role): Observable<User[]> {
        const req = this.buildRequest(RequestMethod.Get);
        return this.authService.authRequest(this.baseUrl + this.userUrl + '/by_rol/' + role.id , req)
            .map(res => res.json().map( t => this.valueToEntity(t) ) );
    }

    protected valueToEntity(value: Object): User {
        return new User(value);
    }

    protected getResourcePath(): string {
        return this.userUrl;
    }

    getDefaultQueryOptions(): QueryOptions {
        return new QueryOptions();
    }
}



// WEBPACK FOOTER //
// ./src/app/core/service/user.service.ts